<img src="../../../../assets/images/background/placeholder/Battery-Roadmap-Blurred.png" class="blurred-image" alt="roadmap request access" />